// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T15:48:02.905Z
// Property: Traders Row (ID: 6737460151193399)
// Collections: 25 amenities, 16 floorplans (live), 35 photos, 38 POIs, 2 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162250",
  "multihub_property_id": "6737460151193399",
  "property_external_id": "723000",
  "property_zillow_url": "https://www.zillow.com/apartments/salem-ma-traders-row-9699Mj/",
  "property_apartments_url": "https://www.apartments.com/traders-row-salem-ma/jlnsg46",
  "property_google_business_url": "https://www.google.com/maps/place/Traders+Row/data=!4m2!3m1!1s0x0:0x27c39928ee1c034c?sa=X&ved=2ahUKEwi22K72u7uSAxVYr1YBHbVtJ54Q_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "18468858452",
  "property_crm_software": "MRI CRM",
  "property_pm_software": "MRI",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "traders-row",
  "property_name": "Traders Row",
  "property_website_url": "https://www.tradersrow.com/",
  "property_domain": "https://www.tradersrow.com/",
  "property_address": "45 Traders Row",
  "property_full_address": "45 Traders Way, Salem, MA 01970",
  "property_address_1": "45 Traders Way",
  "property_address_2": null,
  "property_address_city": "Salem",
  "property_address_state": "MA",
  "property_address_zip_full": "01970",
  "property_address_zip": "01970",
  "property_address_country": "US",
  "property_address_county": "Essex County",
  "property_neighborhood_address": "South Salem",
  "property_address_latitude": "42.5013656",
  "property_address_longitude": "-70.9198226",
  "property_email": "tradersrow@dolben.com",
  "property_phone": "(978) 414-3002",
  "property_call_tracking_phone": "8447321624",
  "property_company_name": "DOLBEN",
  "property_company_url": "https://www.dolben.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Traders Row, where modern living meets comfort in vibrant Salem, MA. Choose from spacious one and two-bedroom floor plans, complete with stainless steel appliances and in-unit laundry. Enjoy amenities like a refreshing pool, state-of-the-art fitness center, and a relaxing lounge. Your ideal lifestyle awaits—schedule a tour today!",
  "property_long_description": "<p>Transform your lifestyle at Traders Row, where smart style meets a savvy sense of what's new and next in Salem living. Trade in hustle for haven with a home base that offers more of what matters, steps from convenient shopping and the iconic Salem Woods. Featuring one and two bedroom apartments for rent in Salem, MA, residents enjoy open floor plans and designer finishes. The amenity spaces include a resort style pool, state-of-the-art fitness center, and ample work from home spaces.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen and living area with island, sofa, chairs, and large window.",
    "public_id": "019d07a0-55e7-763b-b1fc-ecccf685cd9a",
    "storage_key": "property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "212",
  "property_year_built": "2021",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "4.716981132075472",
  "property_admin_fee": "200",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Admin Fee: $200. Application Fee: $50 per applicant",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "The following breeds are strictly prohibited: Rottweiler, Pit Bull (includes: American Pit Bull Terrier, American Staffordshire Terrier, Staffordshire Bull Terrier, American Bulldog, and Bull Terrier), Doberman, Siberian Husky, Akita, Chow, Mastiff, Great Dane, German Shepherd, Dalmatian, Alaskan Malamutes or, any mix of these breeds. For additional information or questions, please contact the leasing office.",
  "property_pet_policy_description": "We are a pet-friendly community! Dogs and cats are permitted - pet rent applies. There are no weight limits for dogs, but we do have breed restrictions.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://idolben.mriprospectconnect.com/723000",
  "property_resident_portal_url": "https://idolben.mriresidentconnect.com/",
  "property_apply_now_url": "https://idolben.mriprospectconnect.com/723000",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/01a121a5-8266-733c-bc98-4f05ed0d9b96.webp",
  "property_primary_logo_media": {
    "alt_text": "Traders Row logo with stylized TR letters and text.",
    "public_id": "01a121a5-8266-733c-bc98-4f05ed0d9b96",
    "storage_key": "property/6737460151193399/01a121a5-8266-733c-bc98-4f05ed0d9b96.webp",
    "width": 800,
    "height": 500
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/01a12142-4803-73a9-9bf2-e22b5eaa7070.webp",
  "property_secondary_logo_media": {
    "alt_text": "Traders Row logo",
    "public_id": "01a12142-4803-73a9-9bf2-e22b5eaa7070",
    "storage_key": "property/6737460151193399/01a12142-4803-73a9-9bf2-e22b5eaa7070.webp",
    "width": 180,
    "height": 109
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/01a155e8-74f4-73dd-83e2-5c6f3b4dfc10.webp",
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/01a121a5-de4f-7338-831a-638d2ce62305.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a121a5-de4f-7338-831a-638d2ce62305",
    "storage_key": "property/6737460151193399/01a121a5-de4f-7338-831a-638d2ce62305.webp",
    "width": 800,
    "height": 500
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/01a121a5-d185-73e2-a7a7-f643c327a890.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a121a5-d185-73e2-a7a7-f643c327a890",
    "storage_key": "property/6737460151193399/01a121a5-d185-73e2-a7a7-f643c327a890.webp",
    "width": 800,
    "height": 500
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162250/019d06ca-ee10-73da-bbff-8e8bec7c587b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162250/01a0e8dd-680d-75c9-beb0-c526714516d5.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#d14c29",
  "property_secondary_color": "#8c1812",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#999999",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "545 - 1325",
  "property_sqft_min": "545",
  "property_sqft_max": "1325",
  "property_price_range": "2460 - 3440",
  "property_price_min": "2466",
  "property_price_max": "3170",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/TradersRowSalem",
  "property_instagram_url": "https://www.instagram.com/traders_row/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJUzUb5SMT44kRTAMc7iiZwyc",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": "Apartments in Salem, MA",
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "With ideally located Salem, MA apartments, the neighborhood surrounding Traders Row has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Check out the neighborhood!",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "<p>With ideally located Salem, MA apartments, the neighborhood surrounding Traders Row has so much to offer. Entertainment, restaurants, schools, &amp; services combine to create a conveniently placed home. Check out the neighborhood!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>We keep it real at the Row. Take a morning loop around Salem Woods, enjoy a good read by the pool, or sweat it out in the gym - there's nothing stopping you from living your best life!</p>",
  "property_applynow_blurb": "At Traders Row in vibrant Salem, MA, your ideal home awaits! Choose between spacious one- and two-bedroom floor plans, complemented by luxurious amenities like a refreshing pool, modern fitness center, and convenient EV charging. Embrace a smoke-free lifestyle and lease online today to claim your spot in this welcoming community!",
  "property_contactus_blurb": "<p>Contact us if you have any questions, for more information, or to schedule your tour of our apartments for rent in Salem, MA.</p>",
  "property_faqs_blurb": "Discover your ideal living space at Traders Row in Salem, MA, where we offer spacious one and two-bedroom floor plans designed for your comfort. Have questions? Browse our FAQs page to find answers to all your inquiries about our community and elevate your apartment living experience today!",
  "property_floorplans_blurb": "<p>Trade in the old for something uniquely you. Our luxury apartments in Salem, MA have been thoughtfully curated with beautiful finishes, open layouts, ample storage, and oversized windows. Explore our floor plans to find the best fit!</p>",
  "property_gallery_blurb": "<p>Lots to see and even more to do! Explore Traders Row and learn why this community has more to offer than just good looks.</p>",
  "property_interactivemap_blurb": "Welcome to Traders Row in vibrant Salem, MA, where chic one- and two-bedroom apartments await. Benefit from modern amenities like a refreshing pool, state-of-the-art fitness center, and convenient EV charging. Enjoy the ease of on-site maintenance, air conditioning, and stainless steel appliances. Use our interactive community map to find your ideal haven!",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "Discover your perfect home at Traders Row in Salem, MA! Choose from our spacious one-bedroom and two-bedroom floor plans designed for modern living. Experience a vibrant community where great friends make great neighbors. Refer a friend to Traders Row today and share the joy of living in our welcoming apartment community!",
  "property_residentaccess_blurb": "<p>With convenient 24/7 access, the resident portal makes it easy for you to request maintenance service and pay your rent online. Log in to get started.</p>",
  "property_reviews_blurb": "<p>Check out our resident reviews!</p>",
  "property_created_at": "1752257380130",
  "property_scheduletour_blurb": "Discover your ideal living space at Traders Row in Salem, MA! Choose from our thoughtfully designed one and two-bedroom floor plans to find the perfect fit for your lifestyle. Schedule a tour today and see what our residents have to say about living in this vibrant community!",
  "property_thankyou_blurb": "<p>A community leasing professional will contact you shortly!</p>",
  "property_virtualtours_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like a virtual tour. Take a look around our new apartments in Salem, MA - we know you'll love it here!</p>",
  "property_copyright": "2025 All Rights Reserved. Traders Row",
  "property_seo_title_home": "Traders Row | Apartments for Rent in Salem, MA",
  "property_seo_description_home": "Traders Row offers luxury 1 & 2 bedroom apartments for rent in Salem, MA. Explore our floor plans, amenities, & the convenient location near Hawthorne Square.",
  "property_seo_title_floorplans": "Floor Plan | One and Two Bedroom Apartments in Salem, MA",
  "property_seo_description_floorplans": "Traders Row offers pet-friendly 1 and 2 bedroom apartments for rent in Salem, MA. Explore our spacious layouts, amenities, and interiors near downtown Salem!",
  "property_seo_title_amenities": "Amenities | Pet-friendly Apartments in Salem, MA",
  "property_seo_description_amenities": "Traders Row offers convenient amenities, including a fitness center, pool, bark park, Amazon Hub Locker, co-working space, patio w/ covered pergola, & more!",
  "property_seo_title_gallery": "Gallery | Luxury Apartments Salem, MA",
  "property_seo_description_gallery": "Traders Row offers the luxury you've been searching for in Salem apartments for rent near downtown. Check out our gallery page & let our photos do the talking.",
  "property_seo_title_virtualtours": "Virtual Tour | Salem, MA Apartments Near Hawthorne Square",
  "property_seo_description_virtualtours": "Explore our brand-new one and two bedroom apartments in Salem, along with unparalleled amenities and thoughtful layouts with a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Traders Row Apartments",
  "property_seo_description_interactivemap": "Experience the vibrant lifestyle at Traders Row in Salem, MA! Dive into our interactive community map to effortlessly browse available one and two-bedroom apartments, complete with luxurious amenities like a refreshing pool, state-of-the-art fitness center, and convenient EV charging. Picture yourself lounging by the grill or relaxing in well-appointed spaces with modern appliances and hassle-free maintenance. Your ideal smoke-free sanctuary awaits—start your journey to your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Salem MA Apartments for Rent",
  "property_seo_description_neighborhood": "Explore Traders Row, conveniently located near downtown Salem with easy access to the MBTA Commuter Rail, Hawthorne Square, and much more! Visit us today!",
  "property_seo_title_contact": "Contact Us | Apartments in Salem Massachusetts",
  "property_seo_description_contact": "Contact us to learn more about our pet-friendly 1, and 2-bedroom apartments, neighborhood, amenities, features, and special offers at Traders Row!",
  "property_seo_title_faqs": "FAQs | Apartments in Salem, MA",
  "property_seo_description_faqs": "Unravel the details of life at Traders Row in Salem, MA, where comfort meets convenience. From spacious one and two-bedroom floor plans to top-notch amenities like a refreshing pool and state-of-the-art fitness center, we cater to your modern lifestyle. Our smoke-free community features essentials such as on-site maintenance, EV charging, and a lounge for your relaxation. Got questions? Our FAQs page is your key to understanding all that Traders Row has to offer. Dive in and discover your next home today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Salem, MA",
  "property_seo_description_reviews": "Join the vibrant community at Traders Row in Salem, MA, where comfort meets convenience! Our residents rave about the inspiring mix of spacious one and two-bedroom floor plans, top-notch amenities like a sparkling pool, fitness center, and EV charging stations. With an on-site property manager and maintenance team, your needs will always be met. Curious about what it's like to call Traders Row home? Dive into authentic reviews from our satisfied residents and see why this smoke-free haven stands out! Your new lifestyle awaits!",
  "property_seo_title_applynow": "Apply Now | Brand New 1 and 2 Bedroom Apartments in Salem",
  "property_seo_description_applynow": "Apply for our brand-new one or two-bedroom apartments for rent and experience one of the best apartment living experiences in Salem, MA near downtown.",
  "property_seo_title_residentaccess": "Resident Access | Traders Row",
  "property_seo_description_residentaccess": "\"Log in to Traders Row's resident portal in Salem, MA for easy access to rent payments, maintenance requests, and exclusive community updates. Streamline your living experience today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Traders Row",
  "property_seo_description_referafriend": "\"Refer a friend to Traders Row in Salem, MA, and elevate your living experience! Great friends make great neighbors—share the joy of our vibrant community today! Discover the perks of living at Traders Row together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Traders Row",
  "property_seo_description_scheduletour": "\"Discover your new home at Traders Row in Salem, MA! Immerse yourself in our vibrant community with modern amenities and scenic surroundings. Schedule a tour today to explore your future apartment and see why Traders Row is the perfect place to call home!\"",
  "property_seo_title_privacy": "Privacy Policy | Traders Row",
  "property_seo_description_privacy": "\"Discover peace of mind at Traders Row in Salem, MA. Our Privacy Policy details how we protect your personal information and ensure your security. View our privacy policy to learn more!\"",
  "property_seo_title_accessibility": "Website Accessibility | Traders Row",
  "property_seo_description_accessibility": "\"Discover how Traders Row in Salem, MA, champions accessibility for all residents and visitors. Our commitment to digital inclusion ensures that everyone can easily navigate our services and community resources. Explore our Accessibility Statement to learn more!\"",
  "property_seo_title_sitemap": "Sitemap | Traders Row",
  "property_seo_description_sitemap": "Discover your dream home at Traders Row in Salem, MA! Explore our comprehensive sitemap to easily navigate through our apartment offerings, amenities, and community features. Take the first step towards your perfect living space—view our website sitemap today!",
  "property_seo_title_thankyou": "Thank You | Traders Row",
  "property_seo_description_thankyou": "Thank you for reaching out to Traders Row in Salem, MA! We appreciate your interest in our vibrant apartment community. A team member will be in touch shortly to assist you in finding your perfect home. Stay tuned for updates about your future at Traders Row!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1793298787057",
  "amenities": [
    {
      "id": "custom_1ca9d9f5-56f3-4e50-af87-4cd2cca462a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Traders Works co-working space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_711689a4-5d13-46d0-b02f-31f54a2e613c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_70a13749-c554-4f0e-9ad5-80acac15094a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9cb4319-4837-4199-b460-549b13cf52d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Resident gathering area & cafe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d1599470-14fd-4b52-a711-be85b03c4ff5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "State-of-the-art fitness center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fff83977-cd16-4931-a568-b095c1a022bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Resort style pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4a72fd07-b17f-4baf-9484-e2d79b2150cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Fire pits and gas grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_72a88ee7-d2d3-4880-8a1a-002e44e4b249",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious patio area with covered pergola",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_28670ecd-dda6-4353-b031-c6837c4256eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Pet friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_912dac9f-43a0-4e72-966e-68e57436f746",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_89399993-88a9-4c82-9fd2-2a133820beea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Amazon Hub Package Delivery System",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf680363-f3d2-4f43-8837-3a9c6e6561d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Detached garages available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3fd4f032-989a-443c-959e-e8a1d8801ad0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Smoke Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eab6a3e6-0404-4259-a860-1fc1c7fc7230",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Proximity to downtown Salem, MBTA Commuter Rail & more",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb09db2f-3494-46b7-863a-c8763c783940",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Adjacent to Salem Woods with 160 acres of greenspace & nature trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_88206b05-07b1-4653-bdd0-50b4cc52bb03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Proud affiliate of the NAA",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c39d1fb3-eb6d-4297-ad10-b5cd6082cd71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Professionally managed by Dolben",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17b96872-d3f9-43dc-969a-c282b95f2851",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "One and two bedroom floor plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9763a645-f949-4263-9329-10ae3251dbec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Designer kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c62fe8ed-57fb-4975-9e3b-5e5fc96c1fd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless steel appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aa815b40-fec1-4a35-bd25-b24062019f9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Granite counters",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_62def8b0-9bf8-4e54-9f40-59b2c91b102e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Plank flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ab5d059-e2bc-4f52-a402-c01b0eb9355e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "In-residence washer & dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0629db7c-3d79-447e-8f1e-033b1ae55b14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Central air conditioning throughout",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d98a0147-33ef-4453-8838-1c815d6f1151",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "external_id": "false",
      "title": "Furnished Apartments Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_2c5676b4-1f36-49c0-9500-74e4fe8c4b9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-6158-769e-b9ad-1f27de981ab8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, leading to a living room with sofa and armchair.",
        "public_id": "019d079f-6158-769e-b9ad-1f27de981ab8",
        "storage_key": "property/6737460151193399/019d079f-6158-769e-b9ad-1f27de981ab8.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Apartment",
      "description": "Open-concept living space featuring a sleek kitchen with granite countertops and stainless steel appliances, flowing into a comfortable living area with stylish furnishings and a large sliding glass door.",
      "link": "false",
      "alt_text": "Modern kitchen with island, leading to a living room with sofa and armchair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d2cfba0e-e5da-41e4-b589-78c4ba9fab96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-76b0-7276-a9c3-0a3503401df4.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019d079f-76b0-7276-a9c3-0a3503401df4",
        "storage_key": "property/6737460151193399/019d079f-76b0-7276-a9c3-0a3503401df4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience elegant living with this fully equipped kitchen, featuring sleek stainless steel appliances and beautiful granite countertops.",
      "link": "false",
      "alt_text": "Modern apartment kitchen with stainless steel appliances and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9857fb4d-5518-485f-894c-41bc5528df29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-76a8-77de-ba8d-fed8b9a58e20.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, accent chairs, coffee table, and TV.",
        "public_id": "019d079f-76a8-77de-ba8d-fed8b9a58e20",
        "storage_key": "property/6737460151193399/019d079f-76a8-77de-ba8d-fed8b9a58e20.webp",
        "width": 1336,
        "height": 891
      },
      "title": "Apartment",
      "description": "Spacious living area featuring comfortable seating, a modern TV, and large windows that let in natural light.",
      "link": "false",
      "alt_text": "Living room with a gray sofa, accent chairs, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b81cf138-a8fa-49fe-b0b1-fd00b4cd5d4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-78f4-76d3-a36e-9510b06e839c.webp",
      "image_media": {
        "alt_text": "A neatly made bed with decorative pillows in a well-lit bedroom, with a glimpse of a bathroom through an open doorway.",
        "public_id": "019d079f-78f4-76d3-a36e-9510b06e839c",
        "storage_key": "property/6737460151193399/019d079f-78f4-76d3-a36e-9510b06e839c.webp",
        "width": 2048,
        "height": 1372
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable bedroom. The space features a plush bed, elegant decor, and convenient access to the en-suite bathroom.",
      "link": "false",
      "alt_text": "A neatly made bed with decorative pillows in a well-lit bedroom, with a glimpse of a bathroom through an open doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c3f0087c-16cd-40f5-95f6-0778c87ca1f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-85ab-7336-8358-d0392668f6f4.webp",
      "image_media": {
        "alt_text": "Living room with sofa, chairs, coffee table, and TV",
        "public_id": "019d079f-85ab-7336-8358-d0392668f6f4",
        "storage_key": "property/6737460151193399/019d079f-85ab-7336-8358-d0392668f6f4.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring comfortable seating, a modern entertainment center, and a large sliding glass door offering exterior views.",
      "link": "false",
      "alt_text": "Living room with sofa, chairs, coffee table, and TV",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec1d982c-1477-4b99-8185-f2d8bef03fe7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d4e62-c38d-72cd-8a72-b49900b5c0a4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with granite countertop.",
        "public_id": "019d4e62-c38d-72cd-8a72-b49900b5c0a4",
        "storage_key": "property/6737460151193399/019d4e62-c38d-72cd-8a72-b49900b5c0a4.webp",
        "width": 2048,
        "height": 1336
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a bathtub with a shower, a toilet, and a vanity with a granite countertop, perfect for relaxation and daily routines.",
      "link": "false",
      "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63a3c47d-2288-4453-8c06-dfb2112ea933",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-882a-70af-b41e-7bc8f66817ba.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment kitchen and living area with dining table in foreground",
        "public_id": "019d079f-882a-70af-b41e-7bc8f66817ba",
        "storage_key": "property/6737460151193399/019d079f-882a-70af-b41e-7bc8f66817ba.webp",
        "width": 1184,
        "height": 864
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with granite countertops and stainless steel appliances, adjacent to a living area and laundry closet. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "Interior view of an apartment kitchen and living area with dining table in foreground",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_68eec2ec-2ea4-4608-bb7c-de02646be2af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d4e62-bcee-758e-aed3-7c1fa277a24f.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating, a long wooden table, and a bar.",
        "public_id": "019d4e62-bcee-758e-aed3-7c1fa277a24f",
        "storage_key": "property/6737460151193399/019d4e62-bcee-758e-aed3-7c1fa277a24f.webp",
        "width": 1336,
        "height": 891
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring plush seating, a communal workspace, and a contemporary bar area perfect for unwinding.",
      "link": "false",
      "alt_text": "Modern lounge area with comfortable seating, a long wooden table, and a bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_926176b7-f7b2-4b55-be60-835ff6c7e187",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-8fd5-727e-8d76-b81fc209d53d.webp",
      "image_media": {
        "alt_text": "Traders Row logo displayed on a large TV screen in the community lounge.",
        "public_id": "019d079f-8fd5-727e-8d76-b81fc209d53d",
        "storage_key": "property/6737460151193399/019d079f-8fd5-727e-8d76-b81fc209d53d.webp",
        "width": 1336,
        "height": 891
      },
      "title": "Community",
      "description": "Welcome to the Traders Row community lounge, featuring a stylish seating area and a large display showcasing the Traders Row logo.",
      "link": "false",
      "alt_text": "Traders Row logo displayed on a large TV screen in the community lounge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_757382b0-bc34-468c-862c-5c2bac24156a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d4e62-f9e0-76a8-8dbe-8a1d326be5f3.webp",
      "image_media": {
        "alt_text": "Traders Row community lounge area with foosball table and seating.",
        "public_id": "019d4e62-f9e0-76a8-8dbe-8a1d326be5f3",
        "storage_key": "property/6737460151193399/019d4e62-f9e0-76a8-8dbe-8a1d326be5f3.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "The community lounge at Traders Row features comfortable seating, a TV, a foosball table, and a kitchenette area.",
      "link": "false",
      "alt_text": "Traders Row community lounge area with foosball table and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_81e0772b-d49d-4f34-a8e5-597e1d04f7d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-95f1-757a-b862-db84cb16f0e7.webp",
      "image_media": {
        "alt_text": "Modern lounge area with plush chairs and a coffee table.",
        "public_id": "019d079f-95f1-757a-b862-db84cb16f0e7",
        "storage_key": "property/6737460151193399/019d079f-95f1-757a-b862-db84cb16f0e7.webp",
        "width": 2048,
        "height": 1373
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish lounge, featuring comfortable seating and contemporary decor.",
      "link": "false",
      "alt_text": "Modern lounge area with plush chairs and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_87a3a8a2-4e4f-4087-a916-80cb018c381f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-9798-74fa-90bc-953d30fde652.webp",
      "image_media": {
        "alt_text": "Modern community lounge with bar seating and TVs displaying the Traders Row logo.",
        "public_id": "019d079f-9798-74fa-90bc-953d30fde652",
        "storage_key": "property/6737460151193399/019d079f-9798-74fa-90bc-953d30fde652.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating, entertainment screens, and a contemporary design.",
      "link": "false",
      "alt_text": "Modern community lounge with bar seating and TVs displaying the Traders Row logo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2389400c-1329-413f-ae0a-9bf317730114",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-9d16-734d-a502-c5f6c32976c7.webp",
      "image_media": {
        "alt_text": "Amazon Hub package lockers in a hallway.",
        "public_id": "019d079f-9d16-734d-a502-c5f6c32976c7",
        "storage_key": "property/6737460151193399/019d079f-9d16-734d-a502-c5f6c32976c7.webp",
        "width": 1196,
        "height": 1600
      },
      "title": "Community",
      "description": "Secure and convenient Amazon Hub package lockers are available for residents to receive deliveries at their leisure.",
      "link": "false",
      "alt_text": "Amazon Hub package lockers in a hallway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6321c51a-2cf4-4a81-9c05-fcf890952745",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-a09d-7606-8500-02c2559075e0.webp",
      "image_media": {
        "alt_text": "Shuffleboard game with red pucks and the number 3 on the court.",
        "public_id": "019d079f-a09d-7606-8500-02c2559075e0",
        "storage_key": "property/6737460151193399/019d079f-a09d-7606-8500-02c2559075e0.webp",
        "width": 1600,
        "height": 1068
      },
      "title": "Community",
      "description": "Enjoy friendly competition with a game of shuffleboard in our community's game room.",
      "link": "false",
      "alt_text": "Shuffleboard game with red pucks and the number 3 on the court.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4cb4c60e-0e54-4241-b633-0ea36a43b142",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-a58e-77eb-b0c5-3a226b4724e5.webp",
      "image_media": {
        "alt_text": "Communal lounge area with foosball table, seating, and TV showing Traders Row logo.",
        "public_id": "019d079f-a58e-77eb-b0c5-3a226b4724e5",
        "storage_key": "property/6737460151193399/019d079f-a58e-77eb-b0c5-3a226b4724e5.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy fun and games in the communal lounge, featuring a foosball table and comfortable seating. Perfect for relaxing or socializing.",
      "link": "false",
      "alt_text": "Communal lounge area with foosball table, seating, and TV showing Traders Row logo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4628153d-d63a-428c-be5a-6850ed1f0ef1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-a64e-72a0-9e14-87ca1a9e43cd.webp",
      "image_media": {
        "alt_text": "Modern fitness center with treadmills, elliptical machines, and weight rack.",
        "public_id": "019d079f-a64e-72a0-9e14-87ca1a9e43cd",
        "storage_key": "property/6737460151193399/019d079f-a64e-72a0-9e14-87ca1a9e43cd.webp",
        "width": 1600,
        "height": 1199
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a full range of cardio and strength training equipment.",
      "link": "false",
      "alt_text": "Modern fitness center with treadmills, elliptical machines, and weight rack.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_629f188f-f6a1-4377-b18b-3eb5fafd2ba0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-aaea-7113-b945-179edd638540.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, rowing machine, and weight lifting equipment.",
        "public_id": "019d079f-aaea-7113-b945-179edd638540",
        "storage_key": "property/6737460151193399/019d079f-aaea-7113-b945-179edd638540.webp",
        "width": 1600,
        "height": 1199
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines and a weight training station for residents.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, rowing machine, and weight lifting equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_90c9bdc5-4981-43ae-8e4a-688f082f5d3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-ac34-73a6-aa1d-67bcfb93f31a.webp",
      "image_media": {
        "alt_text": "Hallway with meeting rooms and offices",
        "public_id": "019d079f-ac34-73a6-aa1d-67bcfb93f31a",
        "storage_key": "property/6737460151193399/019d079f-ac34-73a6-aa1d-67bcfb93f31a.webp",
        "width": 1600,
        "height": 1199
      },
      "title": "Community",
      "description": "Hallway with access to meeting rooms and offices, perfect for business or collaborative work within the community.",
      "link": "false",
      "alt_text": "Hallway with meeting rooms and offices",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d5f48d44-dacd-4e52-a7b3-2ebaf88d0a4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-b3f1-716a-980e-edc6c3fc74a3.webp",
      "image_media": {
        "alt_text": "Pet grooming station with a tub and drying table",
        "public_id": "019d079f-b3f1-716a-980e-edc6c3fc74a3",
        "storage_key": "property/6737460151193399/019d079f-b3f1-716a-980e-edc6c3fc74a3.webp",
        "width": 1600,
        "height": 1199
      },
      "title": "Community",
      "description": "Groom your furry friends at our convenient pet grooming station, featuring a professional tub and a comfortable drying table.",
      "link": "false",
      "alt_text": "Pet grooming station with a tub and drying table",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a65d1bd3-6775-42c7-bd00-805bed9e195b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-b999-77dc-aade-6702a5578c4c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d079f-b999-77dc-aade-6702a5578c4c",
        "storage_key": "property/6737460151193399/019d079f-b999-77dc-aade-6702a5578c4c.webp",
        "width": 1600,
        "height": 1199
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and the beautiful architecture of our community.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_47357475-96cf-4484-bf4e-8b2e764cf54c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-bc0e-75c8-ad23-0ffe7ae7e2d1.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d079f-bc0e-75c8-ad23-0ffe7ae7e2d1",
        "storage_key": "property/6737460151193399/019d079f-bc0e-75c8-ad23-0ffe7ae7e2d1.webp",
        "width": 1600,
        "height": 1199
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and beautiful landscaping. Perfect for relaxation and fun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dccbb0ce-1094-40de-9574-bf97ec2102bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-bae1-77bb-8af1-02e029acfcfb.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit and pool in the background.",
        "public_id": "019d079f-bae1-77bb-8af1-02e029acfcfb",
        "storage_key": "property/6737460151193399/019d079f-bae1-77bb-8af1-02e029acfcfb.webp",
        "width": 1600,
        "height": 1199
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, complete with a fire pit and a sparkling pool, perfect for sunny days.",
      "link": "false",
      "alt_text": "Outdoor seating area with a fire pit and pool in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7ab82039-0f32-4103-aabd-16dc0654e100",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-c293-718d-af2a-f5fe67b0470d.webp",
      "image_media": {
        "alt_text": "Traders Row conference room with large screen TV, conference table, and chairs.",
        "public_id": "019d079f-c293-718d-af2a-f5fe67b0470d",
        "storage_key": "property/6737460151193399/019d079f-c293-718d-af2a-f5fe67b0470d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Conduct business in our modern conference room, equipped with a large screen TV for presentations. A perfect space for meetings and events at Traders Row.",
      "link": "false",
      "alt_text": "Traders Row conference room with large screen TV, conference table, and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4511cd6-be6b-4b38-b528-9cf00e3e7383",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d4e63-2ec2-71eb-bb54-31b710a4c0f0.webp",
      "image_media": {
        "alt_text": "Man playing with dog in apartment complex's dog park.",
        "public_id": "019d4e63-2ec2-71eb-bb54-31b710a4c0f0",
        "storage_key": "property/6737460151193399/019d4e63-2ec2-71eb-bb54-31b710a4c0f0.webp",
        "width": 1600,
        "height": 1068
      },
      "title": "Community",
      "description": "Enjoy our community's dog park, a perfect place for your furry friend to play and socialize.",
      "link": "false",
      "alt_text": "Man playing with dog in apartment complex's dog park.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c2eadf2-857a-4a0c-ad1f-c4302a678dd3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-c8c9-767c-ae17-e21b6783143c.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging stations with cables in front of a pergola and apartment buildings.",
        "public_id": "019d079f-c8c9-767c-ae17-e21b6783143c",
        "storage_key": "property/6737460151193399/019d079f-c8c9-767c-ae17-e21b6783143c.webp",
        "width": 1068,
        "height": 1600
      },
      "title": "Community",
      "description": "Modern electric vehicle charging stations are conveniently located on the property, providing residents with a sustainable and eco-friendly amenity.",
      "link": "false",
      "alt_text": "Electric vehicle charging stations with cables in front of a pergola and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c55a8393-90e8-46bf-9ca2-38324c551944",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-c9e3-774f-a083-c2d45fbff04e.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two built-in stainless steel grills and a stone base, overlooking apartment buildings.",
        "public_id": "019d079f-c9e3-774f-a083-c2d45fbff04e",
        "storage_key": "property/6737460151193399/019d079f-c9e3-774f-a083-c2d45fbff04e.webp",
        "width": 1600,
        "height": 1199
      },
      "title": "Community",
      "description": "Enjoy outdoor entertaining with our state-of-the-art grilling stations, perfect for gathering with friends and neighbors.",
      "link": "false",
      "alt_text": "Outdoor grilling station with two built-in stainless steel grills and a stone base, overlooking apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_630dd515-c709-4d1b-96f1-cd117cb6f0f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-d0ec-7401-8e26-b8345a290a79.webp",
      "image_media": {
        "alt_text": "White pergola structure with arched openings and columns, set against a backdrop of trees in autumn colors and apartment buildings.",
        "public_id": "019d079f-d0ec-7401-8e26-b8345a290a79",
        "storage_key": "property/6737460151193399/019d079f-d0ec-7401-8e26-b8345a290a79.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy the beautiful autumn scenery from this elegant white pergola, a perfect spot to relax outdoors with views of the surrounding apartment buildings and vibrant fall foliage.",
      "link": "false",
      "alt_text": "White pergola structure with arched openings and columns, set against a backdrop of trees in autumn colors and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_af5a722f-d7de-473d-b6fd-3775d996ad8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d4e63-45af-771d-9df8-95c46efe9234.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and a full moon in the sky.",
        "public_id": "019d4e63-45af-771d-9df8-95c46efe9234",
        "storage_key": "property/6737460151193399/019d4e63-45af-771d-9df8-95c46efe9234.webp",
        "width": 1068,
        "height": 1600
      },
      "title": "Community",
      "description": "Modern apartment buildings featuring private balconies and warm, inviting exterior lighting.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and a full moon in the sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0bedb5ca-b202-4b28-b2db-325e437276e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-d967-73be-bee1-9f7450ffb626.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with balconies and dormer windows, bathed in golden hour sunlight.",
        "public_id": "019d079f-d967-73be-bee1-9f7450ffb626",
        "storage_key": "property/6737460151193399/019d079f-d967-73be-bee1-9f7450ffb626.webp",
        "width": 1600,
        "height": 1068
      },
      "title": "Community",
      "description": "Showcasing the elegant exterior of our apartment building, featuring spacious balconies and charming dormer windows, all illuminated by the warm glow of sunset.",
      "link": "false",
      "alt_text": "Exterior view of a multifamily apartment building with balconies and dormer windows, bathed in golden hour sunlight.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3abec8aa-fb9e-4479-b2c2-51646563496f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d4e63-2277-75ae-858c-0ddca6f313fa.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and a paved walkway.",
        "public_id": "019d4e63-2277-75ae-858c-0ddca6f313fa",
        "storage_key": "property/6737460151193399/019d4e63-2277-75ae-858c-0ddca6f313fa.webp",
        "width": 1600,
        "height": 1199
      },
      "title": "Community",
      "description": "This image showcases the exterior of a modern apartment building, featuring multiple levels with balconies, set against a clear blue sky. A paved walkway leads towards the building through a well-maintained grassy area.",
      "link": "false",
      "alt_text": "Exterior view of an apartment building with balconies and a paved walkway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1f9af10-aac9-491b-82f8-111fbc3f740e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-e10f-7728-8345-ba2a7cdfe9a9.webp",
      "image_media": {
        "alt_text": "Exterior of Traders Row apartment buildings with manicured landscaping and signage.",
        "public_id": "019d079f-e10f-7728-8345-ba2a7cdfe9a9",
        "storage_key": "property/6737460151193399/019d079f-e10f-7728-8345-ba2a7cdfe9a9.webp",
        "width": 1600,
        "height": 1199
      },
      "title": "Community",
      "description": "Welcome to Traders Row, featuring modern apartment buildings with attractive exteriors and lush, colorful landscaping.",
      "link": "false",
      "alt_text": "Exterior of Traders Row apartment buildings with manicured landscaping and signage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a482dcfe-a547-498a-897b-102b942f6fa6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-e3a8-72bc-9378-fa1942a507c1.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed and a closet",
        "public_id": "019d079f-e3a8-72bc-9378-fa1942a507c1",
        "storage_key": "property/6737460151193399/019d079f-e3a8-72bc-9378-fa1942a507c1.webp",
        "width": 1184,
        "height": 864
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a king-size bed and an in-closet storage space.",
      "link": "false",
      "alt_text": "Bedroom with a large bed and a closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dd0ed6bf-bcb0-488a-ab08-6ee0842b0465",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-eb17-70d9-abbc-243d56cff216.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living room in apartment.",
        "public_id": "019d079f-eb17-70d9-abbc-243d56cff216",
        "storage_key": "property/6737460151193399/019d079f-eb17-70d9-abbc-243d56cff216.webp",
        "width": 1184,
        "height": 864
      },
      "title": "Apartment",
      "description": "View of a stylish kitchen and living area, perfect for modern living.",
      "link": "false",
      "alt_text": "Modern kitchen and living room in apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b7b82cc-7e08-40fa-bef8-179842b787d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-ea64-754f-a18f-0e056df9c3b9.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and TV, adjacent to a kitchen with a breakfast bar.",
        "public_id": "019d079f-ea64-754f-a18f-0e056df9c3b9",
        "storage_key": "property/6737460151193399/019d079f-ea64-754f-a18f-0e056df9c3b9.webp",
        "width": 1184,
        "height": 864
      },
      "title": "Apartment",
      "description": "Spacious and well-lit living area featuring a comfortable sectional sofa and a modern entertainment center. The open-concept design seamlessly transitions to a stylish kitchen with a breakfast bar, perfect for dining and entertaining.",
      "link": "false",
      "alt_text": "Modern living room with a sectional sofa, coffee table, and TV, adjacent to a kitchen with a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_48b16fe6-1c8e-4d53-b303-6289534015a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d079f-f20e-738c-aa71-50ca0e9b5a47.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, dresser, and artwork above the bed.",
        "public_id": "019d079f-f20e-738c-aa71-50ca0e9b5a47",
        "storage_key": "property/6737460151193399/019d079f-f20e-738c-aa71-50ca0e9b5a47.webp",
        "width": 1184,
        "height": 864
      },
      "title": "Apartment",
      "description": "A beautifully furnished bedroom featuring a comfortable queen-size bed, elegant nightstands with lamps, a modern dresser with a mirror, and captivating artwork.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstands, dresser, and artwork above the bed.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_932f956a-c7df-4c9f-a131-fb4f3909d669",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Rockafellas",
      "poi_type": "Restaurants",
      "poi_address": "231 Essex St, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://rockafellasofsalem.com/",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1GCEA_enUS1110US1110&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzIyMGowajeoAgiwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KfH3b9R6FOOJMWgAOT5dfQCG&daddr=231+Essex+St,+Salem,+MA+01970",
      "poi_item_slug": "rockafellas",
      "poi_latitude": "42.5213678",
      "poi_longitude": "-70.89527919999999",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_3afb920a-cf6d-4fe8-90c0-8fb96d1651cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Finz",
      "poi_type": "Restaurants",
      "poi_address": "86 Wharf St, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.hipfinz.com/",
      "poi_directions_map_url": "https://www.google.com/maps/dir//86+Wharf+St,+Salem,+MA+01970/@42.5195031,-70.9701652,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x89e3146689e0db8b:0xaa9f0ef95d1eb03a!2m2!1d-70.8877644!2d42.5195326?entry=ttu",
      "poi_item_slug": "finz",
      "poi_latitude": "42.5195031",
      "poi_longitude": "-70.9701652",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_ec9698f1-fb29-4941-b738-19612c286ee1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Longboards Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "76 Wharf St, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.longboardsbar.com/",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1GCEA_enUS1110US1110&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzIwM2owajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=Kc9Nv4hmFOOJMSfDWv2mXhyA&daddr=76+Wharf+St,+Salem,+MA+01970",
      "poi_item_slug": "longboards-restaurant",
      "poi_latitude": "42.5194769",
      "poi_longitude": "-70.8886426",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_40ddd274-2ca6-44e9-86fb-0385b12f2839",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Howling Wolf Taqueria",
      "poi_type": "Restaurants",
      "poi_address": "76 Lafayette St, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://howlingwolftaqueria.com/",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1GCEA_enUS1110US1110&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzE4MGowajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KSP4lZZkFOOJMXSh7zZElSXd&daddr=76+Lafayette+St,+Salem,+MA+01970",
      "poi_item_slug": "howling-wolf-taqueria",
      "poi_latitude": "42.5192856",
      "poi_longitude": "-70.89374389999999",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_8972c70b-0291-4522-891b-7d51ae181961",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "The Eaves",
      "poi_type": "Restaurants",
      "poi_address": "337 Somerville Ave, Somerville, MA 02143",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.instagram.com/midnight_eaves",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzEyMGowajmoAgCwAgA&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=Kb_v77MTd-OJMY--njOm3mZb&daddr=1+Bow+Mkt+Wy,+Somerville,+MA+02143 ",
      "poi_item_slug": "the-eaves",
      "poi_latitude": "42.3807822",
      "poi_longitude": "-71.0980036",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_420f13fa-7242-47f7-95c2-c295130a7f32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Hot Tomatoes",
      "poi_type": "Restaurants",
      "poi_address": "79 Bow St, Somerville, MA 02143",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://hottomatoesco.com/",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzEwOGowajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KeUtnOmId-OJMZnxJoAfmAVR&daddr=77+Bow+St,+Somerville,+MA+02143 ",
      "poi_item_slug": "hot-tomatoes",
      "poi_latitude": "42.3815012",
      "poi_longitude": "-71.0999982",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_c01bf996-9b94-4604-9720-4b763bb76e7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Somenya - Soba restaurant",
      "poi_type": "Restaurants",
      "poi_address": "23 Hudson St, Boston, MA 02111",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.somenya.com/",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzE4MWowajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KRmp1OBge-OJMaprC8VpVtZ3&daddr=23+Hudson+St,+Boston,+MA+02111 ",
      "poi_item_slug": "somenya-soba-restaurant",
      "poi_latitude": "42.35051259999999",
      "poi_longitude": "-71.0603043",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_8d56d3b4-0b3c-419c-ae84-80ceecbe5923",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Contessa - Boston",
      "poi_type": "Restaurants",
      "poi_address": "1 Newbury St, Boston, MA 02116",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.contessaristorante.com/boston/?utm_medium=Click&utm_source=GoogleMyBusiness",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigATIHCAIQIRigATIHCAMQIRigATIHCAQQIRigATIHCAUQIRigAdIBBzE4OWowajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KWe7OZPMe-OJMSGNBl_8QaKN&daddr=Rooftop,+3+Newbury+St,+Boston,+MA+02116 ",
      "poi_item_slug": "contessa-boston",
      "poi_latitude": "42.3527354",
      "poi_longitude": "-71.0715154",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_1932d0a2-f76c-4562-9d89-562941d8b0d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Swampscott Mall",
      "poi_type": "Shopping",
      "poi_address": "450B Paradise Rd, Swampscott, MA 01907",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.blacklinere.com/wp-content/uploads/2018/04/Swampscott-MA-The-Shops-at-Vinnin-Square-7.pdf",
      "poi_directions_map_url": "https://www.google.com/maps?s=web&rlz=1C1RXQR_enUS1112US1112&lqi=CjtBdWJ1cm4gTWFsbCBTaG9wcGluZyA0NTBCIFBhcmFkaXNlIFJkLCBTd2FtcHNjb3R0LCBNQSAwMTkwN0jxhp3Y5YCAgAhaURAAEAEQAhgBGAIYAxgEGAUYBhgHGAgiOWF1YnVybiBtYWxsIHNob3BwaW5nIDQ1MGIgcGFyYWRpc2UgcmQgc3dhbXBzY290dCBtYSAwMTkwN5IBD3Nob3BwaW5nX2NlbnRlcqoBfwoIL20vMGhoZGIQASoRIg1tYWxsIHNob3BwaW5nKAAyHxABIhskejRTdart0pzXwkLz_Jum27T0JEQrxIoO8gkyPRACIjlhdWJ1cm4gbWFsbCBzaG9wcGluZyA0NTBiIHBhcmFkaXNlIHJkIHN3YW1wc2NvdHQgbWEgMDE5MDfgAQA&phdesc=JxKpjJDzgps&vet=12ahUKEwiA14q3wbiGAxXhEVkFHfgABVQQ1YkKegQIFhAB..i&cs=0&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KbeJAYKpFOOJMax7JzkXtAcs&daddr=450+Paradise+Rd,+Swampscott,+MA+01907",
      "poi_item_slug": "swampscott-mall",
      "poi_latitude": "42.4827889",
      "poi_longitude": "-70.9045251",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_13d5343d-e2ce-481b-9290-e03ba12cf048",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Whole Foods at Swampscott",
      "poi_type": "Shopping",
      "poi_address": "331 Paradise Rd, Swampscott, MA 01907",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/swampscott",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzM5N2owajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KWf5apWqFOOJMWyrzlpNQ9RW&daddr=331+Paradise+Rd,+Swampscott,+MA+01907",
      "poi_item_slug": "whole-foods-at-swampscott",
      "poi_latitude": "42.4793147",
      "poi_longitude": "-70.905549",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_f5defa9a-9e5b-43ee-9b03-bd96781d16dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Shaw's",
      "poi_type": "Shopping",
      "poi_address": "11 Traders Way, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://local.shaws.com/ma/salem/11-traders-way.html",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIJCAEQIRgKGKABMgkIAhAhGAoYoAEyCQgDECEYChigATIJCAQQIRgKGKABMgcIBRAhGKsC0gEHMTM5ajBqNKgCALACAA&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KSVPHHRpE-OJMZfe0AlQHhOS&daddr=11+Traders+Way,+Salem,+MA+01970",
      "poi_item_slug": "shaw-s",
      "poi_latitude": "42.5017904",
      "poi_longitude": "-70.92154719999999",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_4020be0a-4a9a-460b-98c7-d166724a1bb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Market Basket",
      "poi_type": "Shopping",
      "poi_address": "227 Highland Ave, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.shopmarketbasket.com/store-locations/salem-massachusetts-market-basket-58",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigATIHCAIQIRigATIHCAMQIRigATIHCAQQIRigATIHCAUQIRigATIHCAYQIRirAtIBBzIxNmowajSoAgCwAgA&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KVUHES1vE-OJMe4AkKTum8aa&daddr=227+Highland+Ave,+Salem,+MA+01970",
      "poi_item_slug": "market-basket",
      "poi_latitude": "42.5045169",
      "poi_longitude": "-70.9199654",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_4f870f8e-79ec-4543-9dee-a837ea141676",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "White Dove Market & Grill",
      "poi_type": "Shopping",
      "poi_address": "59 Loring Ave, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://whitedovemarketmenu.com/?utm_source=gbp",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzIzNmowajSoAgCwAgA&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KdMgU1SoFOOJMeZ_-9hjuZZ6&daddr=59+Loring+Ave,+Salem,+MA+01970",
      "poi_item_slug": "white-dove-market-grill",
      "poi_latitude": "42.5021652",
      "poi_longitude": "-70.89381709999999",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_6b14546f-c672-4b34-ba82-a3069973fa74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Crosby's Market Place",
      "poi_type": "Shopping",
      "poi_address": "127 Canal St, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.crosbysmarkets.com/",
      "poi_directions_map_url": "https://www.google.com/maps/dir//Crosby's+Market+Place+Shopping+127+Canal+St,+Salem,+MA+01970/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x89e3148602ae7e4f:0xc3c3f7ee6fa16701?sa=X&ved=1t:3061&ictx=111",
      "poi_item_slug": "crosby-s-market-place",
      "poi_latitude": "42.5093614",
      "poi_longitude": "-70.89583309999999",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_11001fee-9247-426b-9cb0-25cc7394c6c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "The Tin Whistle",
      "poi_type": "Entertainment",
      "poi_address": "243 Jefferson Ave, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tinwhistlesalem.com/",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzE4MmowajSoAgCwAgA&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KU8g3V6DFOOJMeo0MxZHRGPT&daddr=241+Jefferson+Ave,+Salem,+MA+01970",
      "poi_item_slug": "the-tin-whistle",
      "poi_latitude": "42.5066632",
      "poi_longitude": "-70.9012978",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_9cee1c95-cf11-4ec1-b9e2-ab0f1af0a00d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Jaho Coffee Roaster & Wine Bar",
      "poi_type": "Entertainment",
      "poi_address": "57 Loring Ave, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.jaho.com/",
      "poi_directions_map_url": "https://www.google.com/maps/dir//Jaho+Coffee+Roaster+%26+Wine+Bar+Entertainment+57+Loring+Ave,+Salem,+MA+01970/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x89e31538ff93f811:0xf46cadd4793e0f24?sa=X&ved=1t:3061&ictx=111&cshid=1717181097235258",
      "poi_item_slug": "jaho-coffee-roaster-wine-bar",
      "poi_latitude": "42.502302",
      "poi_longitude": "-70.8936461",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_188ecbff-ed3f-440c-aa7a-229178e99938",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Sidelines Sportsbar & Grill",
      "poi_type": "Entertainment",
      "poi_address": "105 Canal St, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://sidelinessportsbar.com/",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzE2NmowajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KT-IxRiGFOOJMVufXVGsSwQw&daddr=105+Canal+St,+Salem,+MA+01970",
      "poi_item_slug": "sidelines-sportsbar-grill",
      "poi_latitude": "42.510404",
      "poi_longitude": "-70.8959181",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_e41a68af-9f97-438a-9717-ef5142257d8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "AOH",
      "poi_type": "Entertainment",
      "poi_address": "105 Boston St, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.salemaoh.com/",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigATIHCAIQIRigATIHCAMQIRigATIHCAQQIRigATIHCAUQIRigAdIBBzE1MWowajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=Kdca-kSBE-OJMQ6X_TpnqX8S&daddr=104+Boston+St,+Salem,+MA+01970",
      "poi_item_slug": "aoh",
      "poi_latitude": "42.5208027",
      "poi_longitude": "-70.912058",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_df632d47-64f0-48a9-8a15-fa1feb26c132",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Paddy Kellys",
      "poi_type": "Entertainment",
      "poi_address": "154 Washington St, Peabody, MA 01960",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.paddykellys.com/",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzE3OGowajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KW-UJ6AKE-OJMdk1yE_CZG68&daddr=154+Washington+St,+Peabody,+MA+01960",
      "poi_item_slug": "paddy-kellys",
      "poi_latitude": "42.5203461",
      "poi_longitude": "-70.93238529999999",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_da8b7e04-4eb5-4868-9beb-4bd739d44c8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Gallows Hill Park",
      "poi_type": "Entertainment",
      "poi_address": "12-14 Langdon St, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://gallowshillsalem.com/",
      "poi_directions_map_url": "https://www.google.com/maps?s=web&rlz=1C1RXQR_enUS1112US1112&lqi=CkFHYWxsb3dzIEhpbGwgUGFyayBFbnRlcnRhaW5tZW50IDEyLTE0IExhbmdkb24gU3QsIFNhbGVtLCBNQSAwMTk3MEj7icWE5oCAgAhaZRAAEAEQAhADGAAYARgCGAgYCRgKIj9nYWxsb3dzIGhpbGwgcGFyayBlbnRlcnRhaW5tZW50IDEyIDE0IGxhbmdkb24gc3Qgc2FsZW0gbWEgMDE5NzAqCAgCEAAQARACKgQIAxADkgEEcGFya5oBI0NoWkRTVWhOTUc5blMwVkpRMEZuU1VSTGFVOWZRbEpuRUFFqgGNARABKiMiH2dhbGxvd3MgaGlsbCBwYXJrIGVudGVydGFpbm1lbnQoADIfEAEiGy-nTGJ0x4FSXjtsCx6Cv4BU9cOL8B1qh3Pa-jJDEAIiP2dhbGxvd3MgaGlsbCBwYXJrIGVudGVydGFpbm1lbnQgMTIgMTQgbGFuZ2RvbiBzdCBzYWxlbSBtYSAwMTk3MOABAA&phdesc=ln9rrMDAtWA&vet=12ahUKEwj2sZuvxriGAxULF1kFHR8oBWIQ1YkKegQIFxAL..i&cs=0&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=Kc0jOEN_E-OJMQI9pXVGkjyH&daddr=Mansell+Pkwy,+Salem,+MA+01970",
      "poi_item_slug": "gallows-hill-park",
      "poi_latitude": "42.51688",
      "poi_longitude": "-70.91087499999999",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_d9ca7ebf-4c49-4e8a-9ad6-c56d62c6524a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Spring Pond Nature Trail",
      "poi_type": "Entertainment",
      "poi_address": "38 Coolidge Ave, Peabody, MA 01960",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.alltrails.com/trail/us/massachusetts/lower-spring-pond",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigAdIBBzE5M2owajSoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KXk3C82wE-OJMQLQXZlGYOHp&daddr=38+Coolidge+Ave,+Peabody,+MA+01960",
      "poi_item_slug": "spring-pond-nature-trail",
      "poi_latitude": "42.5096921",
      "poi_longitude": "-70.944255",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_b78cb3cb-3706-4be6-a099-4a69b66d09c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "East End Peabody Veterans Memorial Park",
      "poi_type": "Entertainment",
      "poi_address": "45 Walnut St, Peabody, MA 01960",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://peabodyma.myrec.com/info/facilities/details.aspx?FacilityID=14703",
      "poi_directions_map_url": "https://www.google.com/maps/dir//East+End+Peabody+Veterans+Memorial+Park+Entertainment+45+Walnut+St,+Peabody,+MA+01960/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x89e3139a4121ba5d:0x9bb8ba9b8d251381?sa=X&ved=1t:3061&ictx=111",
      "poi_item_slug": "east-end-peabody-veterans-memorial-park",
      "poi_latitude": "42.526126",
      "poi_longitude": "-70.923712",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_fb8af60a-ad54-46a4-8fdd-53c66fc86bde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Forest River Park",
      "poi_type": "Entertainment",
      "poi_address": "Forest River Park, 32 Clifton Ave, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.salem.org/listing/forest-river-park/",
      "poi_directions_map_url": "https://www.google.com/maps/dir//Forest+River+Park+Entertainment+Forest+River+Park,+32+Clifton+Ave,+Salem,+MA+01970/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x89e3148ceaa723f1:0x617ee3bbfe905901?sa=X&ved=1t:3061&ictx=111",
      "poi_item_slug": "forest-river-park",
      "poi_latitude": "42.5070492",
      "poi_longitude": "-70.8855729",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_de662d79-47fe-4542-9de1-18e606cdf3cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Lappin Park",
      "poi_type": "Entertainment",
      "poi_address": " 237-245 Essex St, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/lappin-park-salem",
      "poi_directions_map_url": "https://www.google.com/maps/dir//Lappin+Park+Entertainment+237-245+Essex+St,+Salem,+MA+01970/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x89e3147ad7f8f7e1:0x4b13db4dfce796b6?sa=X&ved=1t:3061&ictx=111",
      "poi_item_slug": "lappin-park",
      "poi_latitude": "42.5213292",
      "poi_longitude": "-70.8958839",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_23fd74e5-652f-4215-ab6c-b0f713e1e621",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Endicott College",
      "poi_type": "Education",
      "poi_address": "376 Hale St, Beverly, MA 01915",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.endicott.edu/",
      "poi_directions_map_url": "https://www.google.com/maps/dir//Endicott+College,+376+Hale+St,+Beverly,+MA+01915/@42.5536818,-70.851542,16z/data=!4m9!4m8!1m0!1m5!1m1!1s0x89e3166e41f5ada1:0x2b99dfe0107b1f8d!2m2!1d-70.8436261!2d42.5535151!3e0?entry=ttu",
      "poi_item_slug": "endicott-college",
      "poi_latitude": "42.5536818",
      "poi_longitude": "-70.851542",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_eaaac8cc-6d66-4bdf-b411-59b09ca92324",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Other",
      "poi_address": "29 Traders Way, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.planetfitness.com/gyms/salem-traders-way-ma?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigATIHCAIQIRigATIHCAMQIRigATIHCAQQIRigATIHCAUQIRigAdIBBzE3NGowajSoAgCwAgA&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=Kd3axaBpE-OJMX2EtHCSzKur&daddr=29+Traders+Way,+Salem,+MA+01970",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "42.5023383",
      "poi_longitude": "-70.92043249999999",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_d318eced-a7f8-45a3-90ec-f26c3ec10c24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Club Vital Fitness",
      "poi_type": "Other",
      "poi_address": "98 Swampscott Rd, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.clubvitalfitness.com/",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzI1MWowajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=Kbthv-lQa-OJMXDbgNf2X3_J&daddr=98+Swampscott+Rd,+Salem,+MA+01970",
      "poi_item_slug": "club-vital-fitness",
      "poi_latitude": "42.4937795",
      "poi_longitude": "-70.9206078",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_46ecff98-c07f-4e6c-9ba4-2a847eb00668",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Orangetheory Fitness Swampscott",
      "poi_type": "Other",
      "poi_address": "450 Paradise Rd, Swampscott, MA 01907",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/massachusetts/swampscott/450-paradise-road/?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzE2OWowajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KYGKbpypFOOJMa-MT4iaFwXf&daddr=450+Paradise+Rd,+Swampscott,+MA+01907",
      "poi_item_slug": "orangetheory-fitness-swampscott",
      "poi_latitude": "42.4832683",
      "poi_longitude": "-70.9047085",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_96c17d09-f2e9-4b26-bd98-7d47c1a72388",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "North Shore Children's Hospital",
      "poi_type": "Other",
      "poi_address": "81 Highland Ave, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://salem.massgeneralbrigham.org/locations/pediatric_services",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzE4NmowajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KZVoEIaBFOOJMRBOM7zfal9S&daddr=81+Highland+Ave,+Salem,+MA+01970",
      "poi_item_slug": "north-shore-children-s-hospital",
      "poi_latitude": "42.5112809",
      "poi_longitude": "-70.9068688",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_e9c0383c-032e-402c-b873-df4d9129332b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "North Shore Medical Center",
      "poi_type": "Other",
      "poi_address": "81 Highland Ave, Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://salem.massgeneralbrigham.org/",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzE4NmowajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KZVoEIaBFOOJMRBOM7zfal9S&daddr=81+Highland+Ave,+Salem,+MA+01970",
      "poi_item_slug": "north-shore-medical-center",
      "poi_latitude": "42.5112809",
      "poi_longitude": "-70.9068688",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_387a03b2-a299-443d-9b9a-377f15c37a77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Boston Children's at Peabody",
      "poi_type": "Other",
      "poi_address": "10 Centennial Dr, Peabody, MA 01960",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.childrenshospital.org/about-us/locations/peabody",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1RXQR_enUS1112US1112&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzE3OGowajmoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=Kf-PiIEjg-OJMTaJT0Wo61sj&daddr=10+Centennial+Dr,+Peabody,+MA+01960",
      "poi_item_slug": "boston-children-s-at-peabody",
      "poi_latitude": "42.5261026",
      "poi_longitude": "-70.9532148",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_1f9f7eb1-0607-475a-a8bd-5ee2681fcf23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "BayRidge Hospital",
      "poi_type": "Other",
      "poi_address": "60 Granite St, Lynn, MA 01904",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.beverlyhospital.org/locations--services/locations/bayridge-hospital",
      "poi_directions_map_url": "https://www.google.com/maps?sca_esv=f5a20a2e9138d638&rlz=1C1RXQR_enUS1112US1112&uact=5&gs_lp=Egxnd3Mtd2l6LXNlcnAiNUJheVJpZGdlIEhvc3BpdGFsCU90aGVyCTYwIEdyYW5pdGUgU3QsIEx5bm4sIE1BIDAxOTA0SABQAFgAcAB4AZABAJgBAKABAKoBALgBA8gBAPgBAvgBAZgCAKACAJgDAJIHAKAHAA&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KRnEccQgbeOJMbDMOrQ21PwR&daddr=60+Granite+St,+Lynn,+MA+01904",
      "poi_item_slug": "bayridge-hospital",
      "poi_latitude": "42.4715763",
      "poi_longitude": "-70.9563866",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_9eb90d68-ce0a-4d2d-9acc-b3abb5cdc71d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Turners Seafood at Lyceum Hall",
      "poi_type": "Restaurants",
      "poi_address": "43 Church St, Salem MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.turners-seafood.com/salem-ma",
      "poi_directions_map_url": "",
      "poi_item_slug": "39",
      "poi_latitude": "42.5224285",
      "poi_longitude": "-70.8952529",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_3049b353-c609-49a9-ba27-1df5be8b6e70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "PZA Pizza Salem",
      "poi_type": "Restaurants",
      "poi_address": "331 Lafayette St. Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pzagrille.com/",
      "poi_directions_map_url": "",
      "poi_item_slug": "40",
      "poi_latitude": "42.5056088",
      "poi_longitude": "-70.8904609",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_cd6273ca-10f4-4c36-8ffe-33e019ed80f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Witchside Tavern",
      "poi_type": "Restaurants",
      "poi_address": "283 Derby St. Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://witchsidetavern.com/",
      "poi_directions_map_url": "",
      "poi_item_slug": "41",
      "poi_latitude": "42.5199009",
      "poi_longitude": "-70.8908213",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_11215266-b5d7-4997-b43c-74762f3b4aa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Village Tavern",
      "poi_type": "Restaurants",
      "poi_address": "168 Essex St. Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://villagetavernsalem.com/order",
      "poi_directions_map_url": "",
      "poi_item_slug": "42",
      "poi_latitude": "42.5223003",
      "poi_longitude": "-70.89276509999999",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_2fdab464-69c8-4ca0-a79d-71cdd5a05007",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Bit Bar Salem",
      "poi_type": "Restaurants",
      "poi_address": "278 Derby St. Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://bit.bar/?gad_source=1",
      "poi_directions_map_url": "",
      "poi_item_slug": "43",
      "poi_latitude": "42.52055050000001",
      "poi_longitude": "-70.8910092",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_e9253b60-c4dd-4afe-9ee2-dda48436f50e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "poi_name": "Bambolina",
      "poi_type": "Restaurants",
      "poi_address": "288 Derby St. Salem, MA 01970",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bambolinarestaurant.com/",
      "poi_directions_map_url": "",
      "poi_item_slug": "44",
      "poi_latitude": "42.5204351",
      "poi_longitude": "-70.8916638",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    }
  ],
  "office_hours": [
    {
      "id": "custom_b26c5a0c-f8d8-4d48-a559-e04e6aee88f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_547544b9-d000-4f6c-9565-47c396b0c6c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0ab1e876-b2d3-464e-8404-30af32c698fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ec629a3a-e9a3-4d93-bc65-156931f0d8ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_83f55e63-cbe8-4e30-8d06-8f4128006962",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0e1876e0-d6f1-4d48-81e0-89ef3824f306",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_113d7d54d75c2f4aa5ec575b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "rating": "5",
      "name": "Mike Mann",
      "text": "What makes Traders Row a nice place to live is not just the brand new spacious apartment finishes or the quick access to golf courses and downtown Salem nearby. Rather, it’s the people that work here and care about the residents, whether it be the maintenance staff saying hello to everyone driving by on their golf carts or the cleaning staff who always make a point of flashing a smile. The leasing office is somewhere I regularly stop by at to ensure my pup, who is friends with the entire staff here, makes sure to get all the treats and pets he can handle. Finally, a special shout out to the property manager Danielle Gahagan, who has gone above and beyond in making sure my and other residents time here is comfortable. She truly embodies the kindness of Traders Row.",
      "date": "2023-08-16",
      "title": "false"
    },
    {
      "id": "ec_700fd2a4640f91dab762b64e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "rating": "5",
      "name": "Jennifer Suarez",
      "text": "Frankie was super helpful and kind. He personally called me to get access (which I really appreciated), fixed four service requests in about an hour—pretty great timing if you ask me—and was awesome with my overly friendly dog. Thanks, Frankie!",
      "date": "2025-12-29",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_9d2b0434-d41d-47f4-b00e-c237af4882d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193399/019d07a0-2a0a-7029-9f45-f454945583fe.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern community lounge area with a wet bar, island, seating, and large windows.",
        "public_id": "019d07a0-2a0a-7029-9f45-f454945583fe",
        "storage_key": "property/6737460151193399/019d07a0-2a0a-7029-9f45-f454945583fe.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?model=RYrCK6R9L3A&play=1"
    },
    {
      "id": "custom_67554c01-f3c4-445e-855d-f7ba56b15433",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "1BR, 1BA - 750SF",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yiUhY6FRkZ5&sr=1.26,-1.34&ss=6"
    },
    {
      "id": "custom_bb6674ba-3495-434e-a9bc-b8021cfcfb8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "B2C - 1,035SF",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?play=1&lang=en-US&m=8MVaYimJVFL"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_f7b63a7ade00f4495c7ac156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "engrain",
      "external_id": "362210",
      "name": "Utility - Electric - Third Party",
      "description": "Amount for provision and consumption of electric paid to a third party.",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5ebcf01690d0ce83bfa12da9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "engrain",
      "external_id": "362211",
      "name": "Pet Rent - Cat",
      "description": "false",
      "amount": 40,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "cats",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_53cd7644b0c59d29e7357ed6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "engrain",
      "external_id": "362213",
      "name": "Security Deposit (starting at)",
      "description": "Amount intended to be held through residency that may be applied toward amounts owed at move-out. Refunds processed per application and lease terms.",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_0f650a8616ed8eb95e73e4c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "engrain",
      "external_id": "362214",
      "name": "Parking",
      "description": "false",
      "amount": 85,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c4b8f65e89e32df3d0bc0d03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "engrain",
      "external_id": "362215",
      "name": "Garage Parking",
      "description": "false",
      "amount": 185,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0a77531827d87703d0cdee96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "engrain",
      "external_id": "362216",
      "name": "Utility - Water / Sewer",
      "description": "Amount for provision and / or consumption of water and sewer services.",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4430692c9e7fd0a5e4be1d5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "engrain",
      "external_id": "362217",
      "name": "Renters Liability Insurance - Third Party",
      "description": "Amount for renters liability insurance obtained through resident's provider of choice.",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Varies",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "insurance",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1d520200b7db2f00af201c73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "engrain",
      "external_id": "495883",
      "name": "Pet Rent - Dog",
      "description": "false",
      "amount": 70,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "dogs",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199647c-80f1-753a-9adb-51449bc3e50d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "dolben-traders-row",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-salem-ma",
      "search_query": "in-unit laundry apartments Salem MA",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Salem, MA",
      "h2_subtitle": "Discover modern living with in-unit laundry in Salem, MA. Traders Row offers stylish spaces with all the amenities you need.",
      "page_copy": "Experience unparalleled convenience at Traders Row in scenic Salem, MA. Offering one and two-bedroom apartments, each unit is equipped with in-unit laundry facilities, allowing you more time to enjoy the community’s fantastic amenities. From the stainless-steel appliances in the kitchen to the comfortable plank flooring throughout, every detail has been designed with contemporary living in mind.\n\nBeyond the comfort of your personal retreat, Traders Row boasts a range of amenities to enhance your lifestyle. Dive into relaxation at our refreshing pool or maintain your fitness routine at the state-of-the-art fitness center. Your four-legged friend will love our Bark Park, and remote workers can make the most of Traders Works co-working space. With everything you need at your fingertips, Traders Row is the perfect place to call home in Salem, MA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen and living area with island, sofa, chairs, and large window.",
        "public_id": "019d07a0-55e7-763b-b1fc-ecccf685cd9a",
        "storage_key": "property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Salem, MA",
      "seo_description": "Discover apartments with in-unit laundry at Traders Row in Salem, MA. Enjoy spacious floor plans and modern amenities just for you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-south-salem",
      "search_query": "pet friendly apartments South Salem",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in South Salem",
      "h2_subtitle": "Welcome to Traders Row, your pet-friendly haven in South Salem. Enjoy a community designed with amenities both you and your pet will love.",
      "page_copy": "Nestled in the charming neighborhood of South Salem, Traders Row welcomes you and your furry friends with open arms. Our pet-friendly apartments offer spacious one and two-bedroom floor plans, providing the perfect blend of comfort and convenience. Each unit is thoughtfully designed, featuring modern amenities like stainless steel appliances and in-unit laundry, ensuring you and your pet feel right at home.\n\nTraders Row isn't just a place to live – it's a community. Pets can frolic in the on-site Bark Park, while you relax in the spacious patio area under the covered pergola. Stay active in our state-of-the-art fitness center or focus on work in the Traders Works co-working space. With a refreshing pool to cool off and a relaxing lounge for unwinding, Traders Row is more than just a home; it's a lifestyle you and your pet will cherish in South Salem.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen and living area with island, sofa, chairs, and large window.",
        "public_id": "019d07a0-55e7-763b-b1fc-ecccf685cd9a",
        "storage_key": "property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in South Salem",
      "seo_description": "Find pet-friendly living in South Salem at Traders Row. Enjoy spacious apartments and amenities designed for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "generator",
      "page_item_url": "apartments-with-pool-salem-01970",
      "search_query": "apartments with pool Salem 01970",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Salem 01970",
      "h2_subtitle": "Discover apartment living with a pool in Salem, 01970. Traders Row offers relaxation and recreation right at your doorstep.",
      "page_copy": "Dive into a lifestyle of luxury and leisure at Traders Row, where our stunning pool is just one of the appealing amenities you'll find in Salem, 01970. As you explore our spacious one and two-bedroom apartments, you'll notice modern features such as stainless steel appliances and in-unit laundry, designed to complement the vibrant energy of the surrounding Salem area.\n\nOur community offers more than just a place to live—it's a sanctuary. After a swim, take advantage of the Traders Works co-working space or enjoy a workout in the state-of-the-art fitness center. Unwind in the relaxing lounge, or let your pet enjoy the outdoor freedom of our Bark Park. With our central location in the heart of South Salem, Traders Row combines convenience with unparalleled comfort, making it the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen and living area with island, sofa, chairs, and large window.",
        "public_id": "019d07a0-55e7-763b-b1fc-ecccf685cd9a",
        "storage_key": "property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Salem, 01970",
      "seo_description": "Enjoy poolside living in Salem, 01970 at Traders Row. Modern apartments with top amenities for a lifestyle of comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-near-salem-woods",
      "search_query": "fitness center apartments near Salem Woods",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near Salem Woods",
      "h2_subtitle": "Explore apartments with a fitness center near Salem Woods. Experience vibrant living at Traders Row with modern amenities.",
      "page_copy": "Find your ideal living space at Traders Row, offering fitness-focused living close to the natural beauty of Salem Woods. Our community presents spacious one and two-bedroom apartments that include in-unit laundry and stainless steel appliances, designed for modern comfort. Located near Salem Woods, enjoy easy access to outdoor recreation and scenic trails right in your backyard.\n\nBeyond our prime location, you'll love the on-site amenities tailored to a dynamic lifestyle. Get energized in our state-of-the-art fitness center or take a refreshing swim in the pool. Socialize with neighbors at the spacious patio with a covered pergola, or boost your productivity at the Traders Works co-working space. At Traders Row, convenience meets tranquility, giving you the best of both worlds in South Salem.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen and living area with island, sofa, chairs, and large window.",
        "public_id": "019d07a0-55e7-763b-b1fc-ecccf685cd9a",
        "storage_key": "property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near Salem Woods",
      "seo_description": "Live near Salem Woods at Traders Row. Apartments with a fitness center and modern amenities for a balanced lifestyle in South Salem.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "generator",
      "page_item_url": "electric-vehicle-charging-apartments-salem-ma",
      "search_query": "electric vehicle charging apartments Salem MA",
      "category": "Amenity",
      "h1_title": "EV Charging Apartments in Salem, MA",
      "h2_subtitle": "Discover apartments with electric vehicle charging in Salem, MA. Traders Row offers modern amenities for sustainable living.",
      "page_copy": "Welcome to Traders Row, where sustainable living meets modern comfort in Salem, MA. Our community proudly offers electric vehicle charging stations, ensuring convenience for eco-conscious residents. Choose from our spacious one and two-bedroom floor plans that feature contemporary amenities such as stainless steel appliances and in-unit laundry.\n\nLocated in the vibrant neighborhood of South Salem, you'll have access to both urban conveniences and serene natural surroundings. Our community amenities are designed to enhance your lifestyle, from relaxing by the pool to working out in the state-of-the-art fitness center. Enjoy the Traders Works co-working space, or unwind in the lounge. At Traders Row, you're not just moving into an apartment; you're stepping into a community committed to sustainability and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen and living area with island, sofa, chairs, and large window.",
        "public_id": "019d07a0-55e7-763b-b1fc-ecccf685cd9a",
        "storage_key": "property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "EV Charging Apartments in Salem, MA",
      "seo_description": "Live sustainably at Traders Row in Salem, MA. Apartments with EV charging and modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-salem-ma",
      "search_query": "two bedroom apartments salem ma",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Salem, MA",
      "h2_subtitle": "Discover spacious two-bedroom apartments in Salem, MA. Experience modern living at Traders Row with premium amenities.",
      "page_copy": "Experience the perfect blend of comfort and style in Salem, MA with Traders Row's spacious two-bedroom apartments. Each unit is designed with modern living in mind, featuring stainless steel appliances and in-unit laundry that make daily life effortless. Situated in the lively South Salem neighborhood, you'll enjoy the vibrant community atmosphere that our location provides.\n\nOur extensive amenities cater to varied lifestyles. Take advantage of the refreshing pool and state-of-the-art fitness center right at your doorstep. Host gatherings at the spacious patio area with a pergola or focus on productivity in the Traders Works co-working space. At Traders Row, you'll find not only a place to live but a community to thrive in, balancing convenience and contemporary living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen and living area with island, sofa, chairs, and large window.",
        "public_id": "019d07a0-55e7-763b-b1fc-ecccf685cd9a",
        "storage_key": "property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Salem, MA",
      "seo_description": "Explore two-bedroom apartments at Traders Row in Salem, MA. Enjoy modern amenities and vibrant community living in South Salem.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193399",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-salem",
      "search_query": "one bedroom apartments south salem",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South Salem",
      "h2_subtitle": "Looking for one-bedroom apartments in South Salem? Traders Row offers modern amenities and vibrant community living.",
      "page_copy": "Discover the ideal one-bedroom apartment in South Salem at Traders Row, where modern living complements convenience. Each apartment is thoughtfully designed, offering features like stainless steel appliances and in-unit laundry, ensuring a comfortable and seamless lifestyle. Located in the heart of South Salem, our community provides easy access to both the historic charm and the vibrant energy of the area.\n\nEnjoy a variety of amenities that enhance your living experience. Whether it's staying active in the state-of-the-art fitness center, relaxing by the pool, or utilizing the Traders Works co-working space, Traders Row meets diverse lifestyle needs. Social spaces like our spacious patio with a pergola offer perfect settings for relaxation and community bonding. Embrace a living experience that offers more than just an apartment; find a home at Traders Row.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen and living area with island, sofa, chairs, and large window.",
        "public_id": "019d07a0-55e7-763b-b1fc-ecccf685cd9a",
        "storage_key": "property/6737460151193399/019d07a0-55e7-763b-b1fc-ecccf685cd9a.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in South Salem",
      "seo_description": "Explore modern one-bedroom apartments at Traders Row in South Salem. Enjoy community-focused living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "dania@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3508"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028658241"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WGFBR57M"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://tradersrow.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_cort_lead_form_id",
      "type": "STRING",
      "value": "Traders_Row_bSgsVkCDfICPqgpVA8Ed"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "18468858452"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/ryzvgnlopln"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_mri_tour_scheduler_url",
      "type": "STRING",
      "value": "https://dolben.leadmanagement.mrisoftware.com/schedule/schedProcessor.asp?propID=100063&subID=&refID=100497&logo=1"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imt5WkF5elBBOHJ2U0JhYjRSMlc5RUE9PSIsInZhbHVlIjoiT1pTZFExMW5HUTlDSTZsY3BpRkJCUT09IiwibWFjIjoiOTQzNjA4YjJlODk4MWY0ZDY1OGJhMDlhYjA5MmU4ODhhOGQ4MThiMTZjYzdkMmRlYjdlNWZjMzVhMDRlY2JlZCJ9"
    }
  ],
  "custom_csm": "dania@repli360.com",
  "custom_qb_id": "3508",
  "custom_repli_id": "5028658241",
  "custom_google_gtm_id": "GTM-WGFBR57M",
  "custom_ads_subscription": "none",
  "custom_betterbot_script": "<script src=\"https://tradersrow.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_seo_subscription": "essential",
  "custom_cort_lead_form_id": "Traders_Row_bSgsVkCDfICPqgpVA8Ed",
  "custom_hubspot_company_id": "18468858452",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/ryzvgnlopln",
  "custom_website_subscription": "turnkey",
  "custom_mri_tour_scheduler_url": "https://dolben.leadmanagement.mrisoftware.com/schedule/schedProcessor.asp?propID=100063&subID=&refID=100497&logo=1",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imt5WkF5elBBOHJ2U0JhYjRSMlc5RUE9PSIsInZhbHVlIjoiT1pTZFExMW5HUTlDSTZsY3BpRkJCUT09IiwibWFjIjoiOTQzNjA4YjJlODk4MWY0ZDY1OGJhMDlhYjA5MmU4ODhhOGQ4MThiMTZjYzdkMmRlYjdlNWZjMzVhMDRlY2JlZCJ9",
  "custom_audioeye_site_id": "d157666a-95e1-4df2-9036-53e668432298",
  "custom_audioeye_site_hash": "da5f2a8232d4e740fa92ade87f35b569"
};

export const generatedAt = '2026-11-03T15:48:02.905Z';
